import React, { useEffect, useRef } from "react";
import { Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import FiveProgressBars from "../../../../components/common/FiveProgressBars";
import SixProgressBars from "../../../../components/common/SixProgressBars";
import { useMutation } from "@tanstack/react-query";
import { onboardingApi } from "../../../../api/onboardingApi";
import { extractHexColor } from "../../../../styles/hexOpacity";
import { sendMessage } from "../../../../utils/webview";
import useIsInappWebview from "../../../../hooks/useIsInappWebview";

export default function Result_1() {
  const user = useRecoilValue(userAtom);
  const navigate = useNavigate();
  const isInappWebview = useIsInappWebview();

  const pageKey = "result_1";

  const handleNext = () => {
    navigate(`/onboarding_new/result/2`);
  };

  const { mutate: savePage } = useMutation(
    (pageId: string) => onboardingApi.savePage(pageId),
    {
      onSuccess: () => {},
    }
  );

  function useEffectOnce(callback: () => void) {
    const ref = useRef(false);

    useEffect(() => {
      if (ref.current) return;
      ref.current = true;

      if (typeof callback === "function") {
        callback();
      }
    }, []);
  }

  useEffectOnce(() => {
    savePage(pageKey);
  });

  useEffect(() => {
    if (isInappWebview) {
      const topBackground = extractHexColor(
        theme.vars.palette.Background.Level1
      );
      const bottomBackground = extractHexColor(
        theme.vars.palette.Background.Level1
      );

      if (topBackground && bottomBackground) {
        sendMessage(
          JSON.stringify({
            event: "set_safearea_color",
            params: {
              topColor: `${topBackground}`,
              bottomColor: `${bottomBackground}`,
            },
          })
        );
      }
    }
  }, []);

  return (
    <Stack
      sx={{
        width: "100%",
        py: "30px",
        mx: "auto",
      }}
      justifyContent="center"
    >
      <Stack
        spacing={"60px"}
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{
            textAlign: "center",
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {"답변을 분석하고 있습니다.\n" + "프로그램이 곧 준비됩니다."}
        </CustomTypography>
        {user?.onboardingType === "c" ? (
          <SixProgressBars handleNext={handleNext} />
        ) : (
          <FiveProgressBars handleNext={handleNext} />
        )}
        <CustomTypography
          variant={"Caption"}
          fontWeight={500}
          sx={{
            textAlign: "center",
            color: theme.vars.palette.Content.Medium,
          }}
        >
          {
            "잠시만 기다려주세요. 이미 성공을 경험한\n디스턴싱 유저들의 데이터 포인트 40만 개에 기반해\n내게 꼭 맞는 프로그램을 구성하고 있습니다."
          }
        </CustomTypography>
      </Stack>
    </Stack>
  );
}
